import { BaseEntity } from '../models/base-entity.model';

export class Language extends BaseEntity {
    code: string;
    name: string;
    isSelected: boolean;
}



// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/core/language-selector/language.model.ts